import React from "react";

import { AddNewInfrastructureModal } from "molecules/Modals/AddNewInfrastructureModal";
import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";

const Infrastructures = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/nearbyinfravalues/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, nearbyInfraId }) => {
          try {
            const reqData = { name, nearbyInfraId };
            const { data } = await api("/nearbyinfravalues/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, { name, nearbyInfraId }) => {
          try {
            const reqData = { name, nearbyInfraId };
            const { data } = await api(`/nearbyinfravalues/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/nearbyinfravalues/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Infrastructures"
      addRecord="Add Infrastructure"
      searchRecord="Search Infrastructure"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Type",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
          {
            render: (record) => <td>{record?.nearbyInfraName}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{
        title: "Infrastructure",
        CustomModal: AddNewInfrastructureModal,
      }}
    />
  );
};

export default Infrastructures;
